import { defineStore } from "pinia";

export const useArticleStore = defineStore("ArticleStore", {
  state: () => ({
    news: {},
    news_pagination: {},
    news_home: [],

    insight: [],
    latest_insight: [],
    insight_pagination: {},
    insight_categories: [],

    page_active: 1,
    news_filter: "",
  }),
  getters: {},
  actions: {
    // API
    // ============= NEWS =============
    async getNewsHome() {
      try {
        const res = await $fetch("/api/news/get-news-home", {
          method: "POST",
        });
        this.news_home = res.data.data ?? [];
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getNewsDetail(slug) {
      try {
        return await $fetch("/api/news/get-news-detail", {
          method: "POST",
          body: { slug },
        });
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getNewsInfo(params) {
      try {
        const res = await $fetch("/api/news/get-news-info", {
          method: "POST",
          body: params,
        });

        switch (params.label) {
          case "category":
            this.news_filter = res.data[0].category_name;
          case "archive":
            this.news_filter = res.data[0].archive_name;
        }

        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getNews(params) {
      try {
        const res = await $fetch("/api/news/get-news", {
          method: "POST",
          body: params,
        });

        this.news = { ...this.news, [params.page]: res.data.data };
        if (Object.keys(this.news_pagination).length == 0) {
          this.news_pagination = res.data.pagination;
        }

        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    // ============= INSIGHT =============
    async getLatestInsight() {
      try {
        const res = await $fetch("/api/insight/get-latest-insight", {
          method: "POST",
        });
        this.latest_insight = res.data.data ?? [];
        this.latest_insight = Object.fromEntries(
          Object.entries(this.latest_insight).sort(([a], [b]) =>
            a.localeCompare(b),
          ),
        );
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getInsightDetail(slug) {
      try {
        return await $fetch("/api/insight/get-insight-detail", {
          method: "POST",
          body: { slug },
        });
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getInsightInfo(params) {
      try {
        const res = await $fetch("/api/insight/get-insight-info", {
          method: "POST",
          body: params,
        });

        this.insight_categories = res.data;

        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getInsightByCategory(params) {
      try {
        const res = await $fetch("/api/insight/get-insight-by-category", {
          method: "POST",
          body: params,
        });

        if (!res.data.data) return res;

        if (!this.insight[params.category]) {
          this.insight[params.category] = [];
        }

        this.insight[params.category].push(...res.data.data);
        this.insight[params.category] = this.insight[params.category]?.sort(
          (a, b) => new Date(b.createdon) - new Date(a.createdon),
        );

        this.insight_pagination[params.category] = {
          ...res.data.pagination,
          page_fetched: [
            ...(this.insight_pagination[params.category]?.page_fetched || []),
            params.page,
          ],
        };

        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    // METHOD
    setPageActive(state) {
      this.page_active = state;
    },

    resetNews() {
      this.page_active = 1;
      this.news = {};
      this.news_pagination = {};
    },
    resetNewsFilter() {
      this.news_filter = "";
    },
    resetInsight() {
      this.insight = [];
      this.insight_pagination = {};
      this.insight_categories = [];
    },
  },
});
